import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectlegalRepList = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.legalRepList],
  (user) => user
);
